import React, { Component } from "react";
import {
  StyleSheet,
  Dimensions,
  View,
  KeyboardAvoidingView,
} from "react-native";
import Text from "../../components_v2/TextFont";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import ArTheme from "../../argon-ui/Theme";
import { IconButton } from "../../components_v2/Buttons";
import * as faCharCode from "../../../assets/consts/faCharCodes";
import {
  faCheckSquare,
  faWindowClose,
} from "../../../assets/consts/faCharCodes";
import CheckboxBase from "../../nativeBase-ui/CheckboxBase";

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChange: false,
      useCredit: this.props.user.boolUseUnitCredit,
      increaseCredit: this.props.user.boolIncreaseUnitCredit,
    };
  }
  changeIncreaseCredit() {
    if (this.state.isChange) {
      this.setState({ increaseCredit: !this.state.increaseCredit });
    }
  }
  changeUseCredit() {
    if (this.state.isChange) {
      this.setState({ useCredit: !this.state.useCredit });
    }
  }

  render() {
    return (
      <View style={styles.user}>
        <View
          style={{ flexDirection: "row", alignItems: "center", minWidth: 150 }}
        >
          <IconButton
            style={{
              width: 30,
              height: 30,
              // borderWidth: 1,
              // borderColor: ArTheme.COLORS.MUTED,
              alignItems: "center",
              justifyContent: "center",
              marginStart: 5,
            }}
            icon={{
              code: faCharCode.faUser,
              style: {
                fontFamily: faCharCode.FONT_FAMILIES.PRO_REGULAR,
                fontSize: 20,
                color: "#006666",
              },
            }}
          />
          <View
            style={{
              alignItems: "flex-start",
              flex: 1,
            }}
          >
            <Text>{this.props.user.strUserFullName}</Text>
          </View>
        </View>
        <Text>{this.props.user.strUnitName}</Text>
        {this.state.isChange && (
          <CheckboxBase
            onChange={(v) => this.changeUseCredit()}
            checked={this.state.useCredit ? true : false}
          />
        )}
        {!this.state.isChange && (
          <FontAwesomeIcon
            size={22}
            style={{ marginEnd: 10 }}
            icon={this.state.useCredit ? faCheckSquare : faWindowClose}
            color={ArTheme.COLORS.PLACEHOLDER}
          />
        )}
        {this.state.isChange && (
          <CheckboxBase
            onChange={(v) => this.changeIncreaseCredit()}
            checked={this.state.increaseCredit ? true : false}
          />
        )}
        {!this.state.isChange && (
          <FontAwesomeIcon
            size={22}
            style={{ marginEnd: 10 }}
            icon={this.state.increaseCredit ? faCheckSquare : faWindowClose}
            color={ArTheme.COLORS.PLACEHOLDER}
          />
        )}
        {!this.state.isChange && (
          <IconButton
            onPress={() => {
              this.setState({ isChange: true });
            }}
            style={{
              // width: 50,
              // height: 50,
              // borderRadius: 25,
              // borderWidth: 1,
              borderColor: ArTheme.COLORS.MUTED,
              alignItems: "center",
              justifyContent: "center",
              marginEnd: 10,
            }}
            icon={{
              code: "\uf044",
              style: {
                fontFamily: faCharCode.FONT_FAMILIES.PRO_REGULAR,
                fontSize: 22,
                color: "blue",
              },
            }}
          />
        )}

        {this.state.isChange && (
          <IconButton
            onPress={() => {
              this.props.onSaveEdit(
                this.props.user,
                this.state.useCredit,
                this.state.increaseCredit
              );
            }}
            style={{
              borderColor: ArTheme.COLORS.MUTED,
              alignItems: "center",
              justifyContent: "center",
              marginEnd: 10,
            }}
            icon={{
              code: "\uf14a",
              style: {
                fontFamily: faCharCode.FONT_FAMILIES.PRO_REGULAR,
                fontSize: 22,
                color: "green",
              },
            }}
          />
        )}
      </View>
    );
  }
}
const styles = StyleSheet.create({
  user: {
    // flex: 1,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderColor: ArTheme.COLORS.MUTED,
    padding: 3,
    height: 58,
  },
  CheckBox: {
    alignSelf: "center",
    padding: 0,
    margin: 0,
    width: 16,
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: ArTheme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
});
export default User;
